// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CoreXNav-cls1___67992b9d72caf85dd0b{/*!*/}.CoreXNav-cls2___c91b4c08a08d6b83f7f{flex:1 1 auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CoreXNav-cls1___67992b9d72caf85dd0b",
	"cls2": "CoreXNav-cls2___c91b4c08a08d6b83f7f CoreXNav-cls1___67992b9d72caf85dd0b"
};
export default ___CSS_LOADER_EXPORT___;
